import { render, staticRenderFns } from "./GameNews.vue?vue&type=template&id=406b001c&scoped=true"
import script from "./GameNews.vue?vue&type=script&lang=ts"
export * from "./GameNews.vue?vue&type=script&lang=ts"
import style0 from "./GameNews.vue?vue&type=style&index=0&id=406b001c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b001c",
  null
  
)

export default component.exports